import gql from 'graphql-tag';

const GET_PROJECT = gql`
  query project($where: ProjectWhereUniqueInput!) {
    project(where: $where) {
      id
      name
      description
      status
      priority
      startDate
      endDate
      createdAt
      updatedAt
      owner {
        id
        name
        username
        avatar {
          id
          key
        }
        roles {
          id
          org {
            id
            name
            level
            parentOrg {
              id
            }
          }
          roleItems {
            feature
          }
        }
      }
      team {
        id
        name
        username
        avatar {
          id
          key
        }
        roles {
          id
          roleItems {
            feature
          }
        }
      }
      assignedTasks {
        id
        name
        status
        startDate
        dueDate
        createdAt
        urgency
        requestType
        assigneeUsers {
          id
          name
          username
          avatar {
            id
            key
          }
        }
        channelPartner {
          id
          name
        }
        advertiser {
          id
          name
        }
        projects {
          id
          name
          owner {
            id
            name
            username
            roles {
              id
              roleItems {
                feature
              }
            }
          }
          team {
            id
            name
            username
            roles {
              id
              roleItems {
                feature
              }
            }
          }
        }
      }
      # Tasks whose PRIMARY project is this one — nesting project { id } under the tasks
      # above would trip the server's recursion guard (repeated field name on one path).
      primaryTasks: tasks {
        id
      }
    }
  }
`;

export default GET_PROJECT;
